import { HttpClient } from '@angular/common/http';
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PasswordTools } from '../../../shared/models/password.tools';
import { ListsService } from '../../../shared/services/lists.service';
import { MessageService } from '../../../shared/services/message.service';
import { UserService } from '../../../shared/services/user.service';
;

@Component({
  selector: 'app-try',
  templateUrl: 'try.component.html',
  styleUrls: ['try.component.sass'],
  providers: [TranslatePipe]
})
export class TryComponent implements OnInit, AfterContentChecked {
  signupForm: UntypedFormGroup;
  showSpinner: boolean;
  showPasswordChecks: boolean;
  public showPassword = false;
  showPasswordHints = false;

  tempPass: string;
  checkLength: boolean;
  checkNumbersAndLetters: boolean;
  checkSpecialChars: boolean;
  countries = [];
  partner = 0;

  source = "Unknown";

  ipAddress = '';

  passwordStrongness = 0;
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;

  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];


  constructor(private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    public translate: TranslateService,
    private fb: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    private listsService: ListsService,
    private messageService: MessageService,
    private ref: ChangeDetectorRef,
    private http: HttpClient
  ) {
    this.showSpinner = false;


    this.translate.use(this.translate.getBrowserLang());
    this.getIPAddress();

    this.route.params.forEach((params: Params) => {
      const lang = params['lang'];

      this.partner = params['partner'];

      this.source = params['source'];
      if (this.translate.langs.includes(lang)) {
        this.translate.use(lang);
      }

      if (this.translate.langs.includes(lang)) {
        this.translate.use(lang);
      }


    }).then();




    this.signupForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      phone: [''],
      company: [''],
      country: ['']
    });

    // Lista básica de países (puedes expandirla según necesidad)
    this.countries = [
      { code: 'AW', name: 'Aruba' },
      { code: 'AF', name: 'Afghanistan' },
      { code: 'AO', name: 'Angola' },
      { code: 'AI', name: 'Anguilla' },
      { code: 'AX', name: 'Åland Islands' },
      { code: 'AL', name: 'Albania' },
      { code: 'AD', name: 'Andorra' },
      { code: 'AE', name: 'United Arab Emirates' },
      { code: 'AR', name: 'Argentina' },
      { code: 'AM', name: 'Armenia' },
      { code: 'AS', name: 'American Samoa' },
      { code: 'AQ', name: 'Antarctica' },
      { code: 'TF', name: 'French Southern Territories' },
      { code: 'AG', name: 'Antigua and Barbuda' },
      { code: 'AU', name: 'Australia' },
      { code: 'AT', name: 'Austria' },
      { code: 'AZ', name: 'Azerbaijan' },
      { code: 'BI', name: 'Burundi' },
      { code: 'BE', name: 'Belgium' },
      { code: 'BJ', name: 'Benin' },
      { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
      { code: 'BF', name: 'Burkina Faso' },
      { code: 'BD', name: 'Bangladesh' },
      { code: 'BG', name: 'Bulgaria' },
      { code: 'BH', name: 'Bahrain' },
      { code: 'BS', name: 'Bahamas' },
      { code: 'BA', name: 'Bosnia and Herzegovina' },
      { code: 'BL', name: 'Saint Barthélemy' },
      { code: 'BY', name: 'Belarus' },
      { code: 'BZ', name: 'Belize' },
      { code: 'BM', name: 'Bermuda' },
      { code: 'BO', name: 'Bolivia, Plurinational State of' },
      { code: 'BR', name: 'Brazil' },
      { code: 'BB', name: 'Barbados' },
      { code: 'BN', name: 'Brunei Darussalam' },
      { code: 'BT', name: 'Bhutan' },
      { code: 'BV', name: 'Bouvet Island' },
      { code: 'BW', name: 'Botswana' },
      { code: 'CF', name: 'Central African Republic' },
      { code: 'CA', name: 'Canada' },
      { code: 'CC', name: 'Cocos (Keeling) Islands' },
      { code: 'CH', name: 'Switzerland' },
      { code: 'CL', name: 'Chile' },
      { code: 'CN', name: 'China' },
      {
        code: 'CI', name: 'Côte d\'Ivoire'
      },
      { code: 'CM', name: 'Cameroon' },
      { code: 'CD', name: 'Congo, The Democratic Republic of the' },
      { code: 'CG', name: 'Congo' },
      { code: 'CK', name: 'Cook Islands' },
      { code: 'CO', name: 'Colombia' },
      { code: 'KM', name: 'Comoros' },
      { code: 'CV', name: 'Cabo Verde' },
      { code: 'CR', name: 'Costa Rica' },
      { code: 'CU', name: 'Cuba' },
      { code: 'CW', name: 'Curaçao' },
      { code: 'CX', name: 'Christmas Island' },
      { code: 'KY', name: 'Cayman Islands' },
      { code: 'CY', name: 'Cyprus' },
      { code: 'CZ', name: 'Czechia' },
      { code: 'DE', name: 'Germany' },
      { code: 'DJ', name: 'Djibouti' },
      { code: 'DM', name: 'Dominica' },
      { code: 'DK', name: 'Denmark' },
      { code: 'DO', name: 'Dominican Republic' },
      { code: 'DZ', name: 'Algeria' },
      { code: 'EC', name: 'Ecuador' },
      { code: 'EG', name: 'Egypt' },
      { code: 'ER', name: 'Eritrea' },
      { code: 'EH', name: 'Western Sahara' },
      { code: 'ES', name: 'Spain' },
      { code: 'EE', name: 'Estonia' },
      { code: 'ET', name: 'Ethiopia' },
      { code: 'FI', name: 'Finland' },
      { code: 'FJ', name: 'Fiji' },
      { code: 'FK', name: 'Falkland Islands (Malvinas)' },
      { code: 'FR', name: 'France' },
      { code: 'FO', name: 'Faroe Islands' },
      { code: 'FM', name: 'Micronesia, Federated States of' },
      { code: 'GA', name: 'Gabon' },
      { code: 'GB', name: 'United Kingdom' },
      { code: 'GE', name: 'Georgia' },
      { code: 'GG', name: 'Guernsey' },
      { code: 'GH', name: 'Ghana' },
      { code: 'GI', name: 'Gibraltar' },
      { code: 'GN', name: 'Guinea' },
      { code: 'GP', name: 'Guadeloupe' },
      { code: 'GM', name: 'Gambia' },
      { code: 'GW', name: 'Guinea-Bissau' },
      { code: 'GQ', name: 'Equatorial Guinea' },
      { code: 'GR', name: 'Greece' },
      { code: 'GD', name: 'Grenada' },
      { code: 'GL', name: 'Greenland' },
      { code: 'GT', name: 'Guatemala' },
      { code: 'GF', name: 'French Guiana' },
      { code: 'GU', name: 'Guam' },
      { code: 'GY', name: 'Guyana' },
      { code: 'HK', name: 'Hong Kong' },
      { code: 'HM', name: 'Heard Island and McDonald Islands' },
      { code: 'HN', name: 'Honduras' },
      { code: 'HR', name: 'Croatia' },
      { code: 'HT', name: 'Haiti' },
      { code: 'HU', name: 'Hungary' },
      { code: 'ID', name: 'Indonesia' },
      { code: 'IM', name: 'Isle of Man' },
      { code: 'IN', name: 'India' },
      { code: 'IO', name: 'British Indian Ocean Territory' },
      { code: 'IE', name: 'Ireland' },
      { code: 'IR', name: 'Iran, Islamic Republic of' },
      { code: 'IQ', name: 'Iraq' },
      { code: 'IS', name: 'Iceland' },
      { code: 'IL', name: 'Israel' },
      { code: 'IT', name: 'Italy' },
      { code: 'JM', name: 'Jamaica' },
      { code: 'JE', name: 'Jersey' },
      { code: 'JO', name: 'Jordan' },
      { code: 'JP', name: 'Japan' },
      { code: 'KZ', name: 'Kazakhstan' },
      { code: 'KE', name: 'Kenya' },
      { code: 'KG', name: 'Kyrgyzstan' },
      { code: 'KH', name: 'Cambodia' },
      { code: 'KI', name: 'Kiribati' },
      { code: 'KN', name: 'Saint Kitts and Nevis' },
      { code: 'KR', name: 'Korea, Republic of' },
      { code: 'KW', name: 'Kuwait' },
      {
        code: 'LA', name: 'Lao People\'s Democratic Republic'
      },
      { code: 'LB', name: 'Lebanon' },
      { code: 'LR', name: 'Liberia' },
      { code: 'LY', name: 'Libya' },
      { code: 'LC', name: 'Saint Lucia' },
      { code: 'LI', name: 'Liechtenstein' },
      { code: 'LK', name: 'Sri Lanka' },
      { code: 'LS', name: 'Lesotho' },
      { code: 'LT', name: 'Lithuania' },
      { code: 'LU', name: 'Luxembourg' },
      { code: 'LV', name: 'Latvia' },
      { code: 'MO', name: 'Macao' },
      { code: 'MF', name: 'Saint Martin (French part)' },
      { code: 'MA', name: 'Morocco' },
      { code: 'MC', name: 'Monaco' },
      { code: 'MD', name: 'Moldova, Republic of' },
      { code: 'MG', name: 'Madagascar' },
      { code: 'MV', name: 'Maldives' },
      { code: 'MX', name: 'Mexico' },
      { code: 'MH', name: 'Marshall Islands' },
      { code: 'MK', name: 'North Macedonia' },
      { code: 'ML', name: 'Mali' },
      { code: 'MT', name: 'Malta' },
      { code: 'MM', name: 'Myanmar' },
      { code: 'ME', name: 'Montenegro' },
      { code: 'MN', name: 'Mongolia' },
      { code: 'MP', name: 'Northern Mariana Islands' },
      { code: 'MZ', name: 'Mozambique' },
      { code: 'MR', name: 'Mauritania' },
      { code: 'MS', name: 'Montserrat' },
      { code: 'MQ', name: 'Martinique' },
      { code: 'MU', name: 'Mauritius' },
      { code: 'MW', name: 'Malawi' },
      { code: 'MY', name: 'Malaysia' },
      { code: 'YT', name: 'Mayotte' },
      { code: 'NA', name: 'Namibia' },
      { code: 'NC', name: 'New Caledonia' },
      { code: 'NE', name: 'Niger' },
      { code: 'NF', name: 'Norfolk Island' },
      { code: 'NG', name: 'Nigeria' },
      { code: 'NI', name: 'Nicaragua' },
      { code: 'NU', name: 'Niue' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'NO', name: 'Norway' },
      { code: 'NP', name: 'Nepal' },
      { code: 'NR', name: 'Nauru' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'OM', name: 'Oman' },
      { code: 'PK', name: 'Pakistan' },
      { code: 'PA', name: 'Panama' },
      { code: 'PN', name: 'Pitcairn' },
      { code: 'PE', name: 'Peru' },
      { code: 'PH', name: 'Philippines' },
      { code: 'PW', name: 'Palau' },
      { code: 'PG', name: 'Papua New Guinea' },
      { code: 'PL', name: 'Poland' },
      { code: 'PR', name: 'Puerto Rico' },
      {
        code: 'KP', name: 'Korea, Democratic People\'s Republic of'
      },
      { code: 'PT', name: 'Portugal' },
      { code: 'PY', name: 'Paraguay' },
      { code: 'PS', name: 'Palestine, State of' },
      { code: 'PF', name: 'French Polynesia' },
      { code: 'QA', name: 'Qatar' },
      { code: 'RE', name: 'Réunion' },
      { code: 'RO', name: 'Romania' },
      { code: 'RU', name: 'Russian Federation' },
      { code: 'RW', name: 'Rwanda' },
      { code: 'SA', name: 'Saudi Arabia' },
      { code: 'SD', name: 'Sudan' },
      { code: 'SN', name: 'Senegal' },
      { code: 'SG', name: 'Singapore' },
      { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
      { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
      { code: 'SJ', name: 'Svalbard and Jan Mayen' },
      { code: 'SB', name: 'Solomon Islands' },
      { code: 'SL', name: 'Sierra Leone' },
      { code: 'SV', name: 'El Salvador' },
      { code: 'SM', name: 'San Marino' },
      { code: 'SO', name: 'Somalia' },
      { code: 'PM', name: 'Saint Pierre and Miquelon' },
      { code: 'RS', name: 'Serbia' },
      { code: 'SS', name: 'South Sudan' },
      { code: 'ST', name: 'Sao Tome and Principe' },
      { code: 'SR', name: 'Suriname' },
      { code: 'SK', name: 'Slovakia' },
      { code: 'SI', name: 'Slovenia' },
      { code: 'SE', name: 'Sweden' },
      { code: 'SZ', name: 'Eswatini' },
      { code: 'SX', name: 'Sint Maarten (Dutch part)' },
      { code: 'SC', name: 'Seychelles' },
      { code: 'SY', name: 'Syrian Arab Republic' },
      { code: 'TC', name: 'Turks and Caicos Islands' },
      { code: 'TD', name: 'Chad' },
      { code: 'TG', name: 'Togo' },
      { code: 'TH', name: 'Thailand' },
      { code: 'TJ', name: 'Tajikistan' },
      { code: 'TK', name: 'Tokelau' },
      { code: 'TM', name: 'Turkmenistan' },
      { code: 'TL', name: 'Timor-Leste' },
      { code: 'TO', name: 'Tonga' },
      { code: 'TT', name: 'Trinidad and Tobago' },
      { code: 'TN', name: 'Tunisia' },
      { code: 'TR', name: 'Turkey' },
      { code: 'TV', name: 'Tuvalu' },
      { code: 'TW', name: 'Taiwan, Province of China' },
      { code: 'TZ', name: 'Tanzania, United Republic of' },
      { code: 'UG', name: 'Uganda' },
      { code: 'UA', name: 'Ukraine' },
      { code: 'UM', name: 'United States Minor Outlying Islands' },
      { code: 'UY', name: 'Uruguay' },
      { code: 'US', name: 'United States' },
      { code: 'UZ', name: 'Uzbekistan' },
      { code: 'VA', name: 'Holy See (Vatican City State)' },
      { code: 'VC', name: 'Saint Vincent and the Grenadines' },
      { code: 'VE', name: 'Venezuela, Bolivarian Republic of' },
      { code: 'VG', name: 'Virgin Islands, British' },
      { code: 'VI', name: 'Virgin Islands, U.S.' },
      { code: 'VN', name: 'Viet Nam' },
      { code: 'VU', name: 'Vanuatu' },
      { code: 'WF', name: 'Wallis and Futuna' },
      { code: 'WS', name: 'Samoa' },
      { code: 'YE', name: 'Yemen' },
      { code: 'ZA', name: 'South Africa' },
      { code: 'ZM', name: 'Zambia' },
      { code: 'ZW', name: 'Zimbabwe' },
    ];


    this.signupForm.controls['password'].valueChanges.subscribe(res => {
      this.showPasswordHints = true;
      this.tempPass = res;
      this.setBarColors(4, '#DDD');
      if (this.tempPass) {

        var cc = this.checkStrength(this.tempPass);
        const c = this.getColor(cc);
        this.passwordStrongness = cc;
        this.setBarColors(c.index, c.color);
      }


    });

    this.userService.existUserAndIsValidInBackend().subscribe(res => {
      //  this.hideFullLoading = !res;
      if (res == true) {
        if (this.router.url.length > 3) {

          this.router.navigate([
            this.router.url
              .replace(' ', '')
              .replace('/?url=', '')
              .replace(/%2F/g, '/')
          ]);
        } else {
          this.router.navigate(['/home']);
        }
      }

    });

  }
  onStrengthChanged($event) {

    this.passwordStrongness = $event;
    this.showPasswordChecks = ($event < 90 && $event > 10) ? true : false;
  }

  ngAfterContentChecked(): void {
    this.ref.detectChanges();
  }

  ngOnInit() {

    this.showPasswordChecks = false;

  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  getIPAddress() {

    try {
      this.http.get<{ ip: string }>('https://api.ipify.org/?format=json')
        .subscribe(
          data => {
            if (data && data.hasOwnProperty('ip')) {
              this.ipAddress = data['ip'];
            }
          },
          () => {

          });
    } catch (error) {
    }
  }

  getColor(s) {
    let index = 0;
    if (s === 10) {
      index = 0;
    } else if (s === 20) {
      index = 1;
    } else if (s === 30) {
      index = 2;
    } else if (s === 40) {
      index = 3;
    } else {
      index = 4;
    }
    return {
      index: index + 1,
      color: this.colors[index]
    };
  }

  setBarColors(count, col) {
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
    }
  }

  signupFormSubmit() {
    const name = this.signupForm.get('name').value;
    const email = this.signupForm.get('email').value;
    const phone = this.signupForm.get('phone').value;
    const country = this.signupForm.get('country').value;

    const password = PasswordTools.SHA1(this.signupForm.get('password').value);


    this.showSpinner = true;


    const langCode = this.listsService.getLanguageCode(this.translate.currentLang);


    this.userService.signup(name, email, password, langCode, this.partner, this.ipAddress, phone, this.source, country).subscribe(
      () => {
        this.showSpinner = false;
        //   this.step = 4;
        this.router.navigate(['/signup/done'], { queryParams: { email: email } }).then();
      },
      err => {
        this.showSpinner = false;
        switch (err) {
          case 'EXIST_A_USER_WITH_THIS_EMAIL':
            this.messageService.showMessage('MESSAGE_CONTROL.LOGIN.EMAIL_EXISTS');
            break;

          case '"USER_INVALID"':
            this.messageService.showMessage('MESSAGE_CONTROL.LOGIN.INVALID_USERS');
            break;

          default:
            this.messageService.showMessage('MESSAGE_CONTROL.LOGIN.USER_OR_PASSWORD_WRONG');
        }
      },
      () => {
      }
    );
  }

  checkStrength(p) {
    // 1
    let force = 0;

    // 2
    const regex = /[$-/:-?{-~!"^_@`\[\]]/g;
    const lowerLetters = /[a-z]+/.test(p);
    const upperLetters = /[A-Z]+/.test(p);
    const numbers = /[0-9]+/.test(p);
    const symbols = regex.test(p);

    // 3
    const flags = [lowerLetters, upperLetters, numbers, symbols];

    // 4
    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    // 5
    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // 6
    force = (p.length <= 6) ? Math.min(force, 10) : force;

    // 7
    force = (passedMatches === 1) ? Math.min(force, 10) : force;
    force = (passedMatches === 2) ? Math.min(force, 20) : force;
    force = (passedMatches === 3) ? Math.min(force, 30) : force;
    force = (passedMatches === 4) ? Math.min(force, 40) : force;

    return force;
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

}
